import { MAP_TYPES } from '@deck.gl/carto';

const DISTRICTBOUNDARIES_SOURCE_ID = 'districtBoundariesSource';

const source = {
  id: DISTRICTBOUNDARIES_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'cartointegration',
  data: `district_boundaries_source`,

};

export default source;
